/* One savings number everywhere on the product page, matching the cart drawer (Kevin, 11 Oct 2026).
 * For each pack: saving = (compare-at price - subscription price) + every FREE item in that pack's
 * Free Welcome Kit at the kit's crossed-out prices, with free shipping counted at the real
 * standard rate ($7.95). Compare-at = the 1 month price x the months (buying a month at a time),
 * so the saving is genuine. Rounded to the nearest dollar.
 *   - Pack card ribbons (blue) + Subscribe card (green):  SAVE $X
 *   - Subscribe card badge (red): saving / (compare-at + gift values), rounded to nearest
 * Loaded from snippets/gnt-welcome-kit-card.liquid; remove that line to undo.
 */
(function () {
  'use strict';
  var pdp = /^\/products\/([^/?#]+)/.exec(location.pathname);
  var card = document.querySelector('[data-gnt-wk-option="subscribe"]');
  var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (!pdp || !card || !form) return;
  var section = card.closest('[id^="shopify-section"]') || document;

  var cents = function (t) { var m = /\$?\s*([\d,]+(?:\.\d+)?)/.exec(t || ''); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0; };
  var months = function (t) { var m = /(\d+)\s*month/i.exec(t || ''); return m ? parseInt(m[1], 10) : 0; };
  var dollars = function (c) { return '$' + Math.round(c / 100); }; // nearest dollar (Kevin, 12 Oct)

  var SHIPPING = 795; // standard one-off shipping, what free shipping actually saves
  var isShipping = function (li) { return /shipping/i.test((li.querySelector('.gnt-wk-kit__title') || {}).textContent || ''); };
  // Free kit items for a pack (by its tier: 1mo / 3mo / 6mo).
  function giftValue(n) {
    var total = 0;
    card.querySelectorAll('.gnt-wk-kit__item[data-gnt-wk-tier="' + n + 'mo"]').forEach(function (li) {
      if (!li.querySelector('.gnt-wk-kit__free')) return;
      if (isShipping(li)) { total += SHIPPING; return; }
      var s = li.querySelector('.gnt-wk-kit__strike');
      if (s) total += cents(s.textContent);
    });
    return total;
  }
  // The kit's free-shipping row shows the real rate too.
  function shippingRows() {
    card.querySelectorAll('.gnt-wk-kit__item').forEach(function (li) {
      if (isShipping(li)) setText(li.querySelector('.gnt-wk-kit__strike'), '$7.95');
    });
  }
  // The variant for a pack size, matching the customer's other choices (e.g. Original / Vented).
  function variantFor(n) {
    var cur = product.variants.filter(function (v) { return String(v.id) === String(form.value); })[0];
    var same = product.variants.filter(function (v) { return months(v.title) === n; });
    return same.filter(function (v) { return cur && v.option2 === cur.option2 && v.option3 === cur.option3; })[0] || same[0];
  }
  function packNumbers(n) {
    var v = variantFor(n);
    if (!v) return null;
    var alloc = (v.selling_plan_allocations || [])[0];
    var full = Math.max(v.price, v.compare_at_price || 0);
    var gifts = giftValue(n);
    var save = full - (alloc ? alloc.price : v.price) + gifts;
    return { save: save, pct: Math.round(save / (full + gifts) * 100), once: full - v.price };
  }

  var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
  function update() {
    if (!product) return;
    shippingRows();
    // Blue ribbons on the pack cards
    section.querySelectorAll('.variant-card').forEach(function (c) {
      var n = months((c.querySelector('.variant-title') || {}).textContent);
      var rib = c.querySelector('.variant-discount');
      var p = n && packNumbers(n);
      if (!rib || !p || p.save <= 0) return;
      setText(rib, 'SAVE ' + dollars(p.save));
      if (rib.style.display === 'none') rib.style.display = '';
    });
    // Green SAVE + red % on the Subscribe card, for the pack that's selected
    var cur = product.variants.filter(function (v) { return String(v.id) === String(form.value); })[0];
    var p = cur && packNumbers(months(cur.title));
    if (!p) return;
    setText(card.querySelector('[data-gnt-wk-savings]'), 'SAVE ' + dollars(p.save));
    setText(card.querySelector('[data-gnt-wk-discount-badge]'), p.pct + '% OFF');
    tapeRowPrice(cur);
  }

  // Tape row in the kit: crossed-out one-off price, then the subscription price.
  var price = function (c) { var v = c / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
  function tapeRowPrice(v) {
    var li = [].filter.call(card.querySelectorAll('.gnt-wk-kit__item.is-active'), function (x) { return !x.querySelector('.gnt-wk-kit__free'); })[0];
    var amt = li && li.querySelector('.gnt-wk-kit__amount');
    var strike = li && li.querySelector('.gnt-wk-kit__strike');
    if (!amt) return;
    var full = Math.max(v.price, v.compare_at_price || 0); // crossed-out = compare-at (months x 1 month price)
    var alloc = (v.selling_plan_allocations || [])[0];
    var pay = alloc ? alloc.price : v.price;
    setText(amt, price(pay));
    if (strike) { setText(strike, price(full)); strike.style.visibility = full > pay ? '' : 'hidden'; }
  }

  var product = null;
  var pending = false;
  var schedule = function () {
    if (pending) return;
    pending = true;
    // setTimeout, not requestAnimationFrame: the theme writes its own figures right after a pack
    // change and ours must land straight after, even if the tab isn't painting yet.
    setTimeout(function () { pending = false; obs.disconnect(); update(); obs.observe(section, { childList: true, subtree: true, characterData: true }); }, 0);
  };
  var obs = new MutationObserver(schedule);
  ['change', 'click'].forEach(function (e) { section.addEventListener(e, function () { [0, 60, 150, 300, 650].forEach(function (d) { setTimeout(schedule, d); }); }); });
  fetch('/products/' + pdp[1] + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) { product = p; schedule(); })
    .catch(function () {});
})();
